import React from 'react';

import './EmptyState.scss';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

function EmptyState() {
  return (
    <>
      <WpIllustration
        className="align-self-center mt-5"
        width="123"
        src={Illustrations.person_reading_book_in_front_of_window_purple_bg}
      />
      <div className="mt-4 mb-5 your-feed-empty-state-text text-center align-self-center mx-5 px-3">
        Notifications for you and your team’s activity will show here to keep you in the loop.
      </div>
    </>
  );
}

export default EmptyState;
